import { TiersPartie } from '@core-lib/enums';
import { camelCaseToPascalCase } from '@core-lib/functions/utils.function';
import { IDegreRisque, IDepartement, INatureAffaire, IPays } from '@core-lib/models';

export function getTextKeyCloseCompte(result: any): string {
	switch (true) {
		case result.codesNonRespectes[0] === 'ERR_SIGNATURES_ACTIVES':
			return 'ErrSignatureActive';
		case result.codesNonRespectes[0] === 'ERR_AFFAIRES_NON_SOLDEES':
			return 'ErrAffairesNonSoldees';
		case result.codesNonRespectes[0] === 'ERR_OPERATIONS_NON_RAPPROCHEES':
			return 'ErrOpsNonRapprochees';
		default:
			return 'ClotureCompteSucces';
	}
}
